<div class="me-4">
  @if(authService.currentMandat) {
  @if(authService.currentMandat.Avatar) {
  <img class="max-h-8" [src]="authService.currentMandat.Avatar">
  }
  @else {
  <h1>{{authService.currentMandat.Name}}</h1>
  }
  }

  @else if(!authService.currentMandat && authService.isUserGlobalAdmin) {
  <h1><b>Admin dashboard</b> </h1>
  }

  @else {
  <h1>Mandat unable to be solved</h1>
  }
</div>
